import { useState } from "react";
import { addCategory, updateCategory } from "../../../firebase/services";
import { B, fonts, Input, Btn, ImageUpload } from "../../../components/UI";

// Category create/edit form extracted from Dashboard.
export default function CategoryForm({ initial, nextOrder, onDone, showToast, onSavingChange }) {
  const blank = { name: "", slug: "", icon: "👗", order: nextOrder };
  const [form, setForm] = useState(initial || blank);
  const [imgFile, setImgFile] = useState(null);
  const [preview, setPreview] = useState(initial?.bannerUrl || null);
  const [saving, setSaving] = useState(false);
  const set = (k, v) => setForm(f => ({ ...f, [k]: v }));

  const handleSave = async () => {
    setSaving(true);
    onSavingChange?.(true);
    try {
      if (initial) await updateCategory(initial.id, form, imgFile);
      else await addCategory(form, imgFile);
      showToast(initial ? "Category updated" : "Category added");
      onDone();
    } catch (e) {
      showToast(e.message, B.red);
    } finally {
      setSaving(false);
      onSavingChange?.(false);
    }
  };

  return (
    <div style={{ background: B.orangeFaint, border: `1.5px solid ${B.orangeMid}`, borderRadius: 14, padding: 24, marginBottom: 24 }}>
      <div style={{ fontWeight: 800, fontSize: 16, color: B.text, marginBottom: 20, fontFamily: fonts.adminDisplay }}>
        {initial ? "✏️ Edit Category" : "✨ Add Category"}
      </div>
      <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "0 18px" }}>
        <Input label="Category Name" value={form.name} onChange={e => set("name", e.target.value)} placeholder="e.g. 2 Pcs Set" />
        <Input label="URL Slug" value={form.slug} onChange={e => set("slug", e.target.value.toLowerCase().replace(/\s/g, "-"))} placeholder="e.g. 2pcs" />
        <Input label="Icon (emoji)" value={form.icon} onChange={e => set("icon", e.target.value)} placeholder="e.g. 👗" />
        <Input label="Display Order" value={form.order} onChange={e => set("order", parseInt(e.target.value, 10) || 0)} type="number" />
      </div>
      <ImageUpload preview={preview} onFile={f => { setImgFile(f); setPreview(URL.createObjectURL(f)); }} label="Category Banner Image" hint="Wide image (1200×400px ideal)" width={160} height={80} />
      <div style={{ display: "flex", gap: 10, justifyContent: "flex-end" }}>
        <Btn onClick={onDone} variant="ghost">Cancel</Btn>
        <Btn onClick={handleSave} disabled={saving} variant="primary">{saving ? "Saving..." : initial ? "Save" : "Add Category"}</Btn>
      </div>
    </div>
  );
}
